
















































import { IVehicle } from "@/models/vehicle.entity";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import MTextField from "../utility/mmmint/MTextField.vue";
import NumberplateForm from "../utility/NumberplateForm.vue";

@Component({
  components: { NumberplateForm, MTextField }
})
export default class SharedContentVehicleCard extends Vue {
  @Prop()
  vehicle!: IVehicle;

  get partner() {
    return ReportModule.partner;
  }
}
